import { Component, ElementRef, Input, HostListener } from '@angular/core';

@Component({
  selector: 'dev-wrapper',
  templateUrl: 'dev-wrapper.html'
})
export class DevWrapperComponent {
  @Input() parent;
  constructor(private elementRef: ElementRef) {
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setIonContentHeight();
  }

  ngAfterViewChecked() {
    this.setIonContentHeight();
  }

  get breadcrumbsHeight() {
    return this.getElementHeight('dev-breadcrumbs')
  }

  get headerHeight() {
    const _element = document.querySelector('.dev-header');
    return _element['offsetHeight']
  }

  get jumbotronHeight() {
    return this.getElementHeight('dev-jumbotron')
  }

  get screenHeight() {
    return window.innerHeight;
  }

  getElementHeight(element) {
    const _element = this.elementRef.nativeElement.querySelector('.' + element);
    return _element.offsetHeight;
  }

  setIonContentHeight() {
    let ionContentHeight = this.screenHeight;
    ionContentHeight -= this.jumbotronHeight;
    ionContentHeight -= this.breadcrumbsHeight;
    ionContentHeight -= this.headerHeight;

    let ionContent = this.elementRef.nativeElement.querySelector('ion-content .scroll-content');

    ionContent.style.height = ionContentHeight + 'px';
  }


}



// WEBPACK FOOTER //
// ./src/components/dev-wrapper/dev-wrapper.ts